import React, { useState } from "react"
import { Button, Col, Container, Input, Row } from "reactstrap"
import FilterInTable from "../../../../Manage/FilterInTable"
import DataTable from "react-data-table-component"
import { customStyles } from "../DataTableStyles"
import ModalTemplate from "../../../../../components/common/Modal/Modal"

const PersonalizedMessages = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const data = [
    { name: "Birthday Message", dateAdded: "20/06/2024", message: "Happy Birthday! Enjoy your gift." },
    { name: "Birthday Message", dateAdded: "20/06/2024", message: "Happy Birthday! Enjoy your gift." },
  ]

  const columns = [
    { name: "Name", selector: (row) => row.name, grow: 1 },
    { name: "Date Added", selector: (row) => row.dateAdded, grow: 1 },
    { name: "Message", selector: (row) => row.message, grow: 2 },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center">
          <div style={{ padding: ".3rem .8rem", border: "1px solid black", borderRadius: ".5rem" }} onClick={() => console.log(row.name)}>
            Edit
          </div>
          <div>Delete</div>
        </div>
      ),
      grow: 1,
    },
  ]

  return (
    <Container fluid>
      <ModalTemplate isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />

      <h5 className="fw-medium my-3">Personalized Messages</h5>

      <div className="bg-white p-1">
        <div className="m-1 p-3" style={{ border: "2px solid #D9D9D9" }}>
          <div>Enable/Disable Personalized Messages:</div>
          <Row className="align-items-center my-3">
            <Col sm='12' lg="2">Set Character Limits:</Col>
            <Col sm='12' lg="2">
              <Input type="text" placeholder="300 words" />
            </Col>
          </Row>
        </div>
      </div>

      <div className="d-flex justify-content-between">
        <h5 className="fw-medium my-3">Manage Message Templates</h5>
        <Button
          color="info"
          style={{
            backgroundColor: "#48b9e2 !important",
            borderColor: "#48b9e2 !important",
          }}
          className="mt-3 d-flex align-items-center justify-content-between fw-medium"
          onClick={() => setIsModalOpen(true)}
        >
          Add New Templete
        </Button>
      </div>

      <div className="bg-white p-1 mt-3">
        <div className="m-1 p-3" style={{ border: "2px solid #D9D9D9" }}>
          <FilterInTable componentName="Existing Gift Wrapping Options" />

          <DataTable columns={columns} data={data} customStyles={customStyles} highlightOnHover />
        </div>
      </div>
    </Container>
  )
}

export default PersonalizedMessages
